import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
import { CTAButton } from './ui/CTAButton';
import { ShieldCheckIcon, LockIcon, CreditCardIcon, ZapIcon } from 'lucide-react';
export function FinalCTASection() {
  const {
    minutes,
    seconds,
    isUrgent
  } = useCountdown(15);
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  return <section className="py-14 md:py-24 px-4 bg-brand-dark text-white text-center" data-id="element-84">
      <div className="max-w-2xl mx-auto" data-id="element-85">
        <div className="inline-block bg-white/10 text-white font-bold px-6 py-2 rounded-full mb-5 md:mb-8 border border-white/20" data-id="element-86">
          ⛏️ MEGAPACK ESPECIALIZACIONES MINERAS
        </div>

        <h2 className="text-2xl md:text-5xl font-black mb-5 md:mb-8 leading-tight" data-id="element-87">
          El próximo fin de semana podés seguir buscando cursos en YouTube en
          inglés, mal explicados y sin contexto argentino.
          <br data-id="element-88" />
          <span className="text-brand-orange" data-id="element-89">
            O podés tener todo resuelto desde hoy.
          </span>
        </h2>

        <div className="bg-[#252542] p-5 md:p-8 rounded-3xl border border-gray-700 mb-8 md:mb-10" data-id="element-90">
          <p className="text-lg md:text-xl font-bold text-gray-300 mb-4" data-id="element-91">
            ⏰ El precio de lanzamiento cierra en:
          </p>
          <div className={`flex justify-center gap-4 mb-4 ${isUrgent ? 'animate-pulse' : ''}`} data-id="element-92">
            <div className="text-4xl md:text-5xl font-black text-brand-orange" data-id="element-93">
              {formatTime(minutes)}
              <span className="text-sm text-gray-400 ml-1" data-id="element-94">min</span>
            </div>
            <div className="text-4xl md:text-5xl font-black text-gray-500" data-id="element-95">
              :
            </div>
            <div className={`text-4xl md:text-5xl font-black ${isUrgent ? 'text-red-500' : 'text-brand-orange'}`} data-id="element-96">
              {formatTime(seconds)}
              <span className="text-sm text-gray-400 ml-1" data-id="element-97">seg</span>
            </div>
          </div>
          <p className="text-red-400 font-bold text-sm" data-id="element-98">
            Después sube a $49.900 ARS y no vuelve a bajar.
          </p>
        </div>

        {/* Single Product */}
        <div className="bg-white text-brand-dark rounded-2xl p-5 md:p-6 border-3 border-brand-orange shadow-xl mb-6 text-left" data-id="element-99">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3" data-id="element-100">
            <div data-id="element-101">
              <h3 className="text-lg md:text-xl font-black flex items-center gap-2" data-id="element-102">
                🔨 PACK PROFESIONAL
              </h3>
              <p className="text-xs md:text-sm text-gray-500 mt-1" data-id="element-103">
                52 cursos + softwares + seguridad + 3 bonos
              </p>
            </div>
            <div className="flex items-center gap-2" data-id="element-104">
              <span className="text-gray-400 text-sm line-through font-bold" data-id="element-105">
                $49.900
              </span>
              <span className="text-3xl md:text-4xl font-black text-brand-orange" data-id="element-106">
                $19.990
              </span>
              <span className="text-xs text-gray-500 font-medium" data-id="element-107">ARS</span>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="mb-8" data-id="element-108">
          <CTAButton text="→ QUIERO MI MEGAPACK AHORA" href="https://checkout.guiadigital360.online/cart/44819876446277:1" isLink={true} data-id="element-109" />
        </div>

        <div className="flex flex-wrap justify-center items-center gap-4 md:gap-6 text-xs md:text-sm text-gray-400 font-medium" data-id="element-110">
          <span className="flex items-center gap-1.5" data-id="element-111">
            <LockIcon className="w-4 h-4" data-id="element-112" /> Pago seguro
          </span>
          <span className="flex items-center gap-1.5" data-id="element-113">
            <ZapIcon className="w-4 h-4 text-yellow-500" data-id="element-114" /> Acceso en 5 min
          </span>
          <span className="flex items-center gap-1.5" data-id="element-115">
            <ShieldCheckIcon className="w-4 h-4 text-brand-green" data-id="element-116" /> Garantía 7
            días
          </span>
          <span className="flex items-center gap-1.5" data-id="element-117">
            <CreditCardIcon className="w-4 h-4" data-id="element-118" /> Mercado Pago
          </span>
        </div>
      </div>
    </section>;
}